export default "__VITE_ASSET__DQlaBhO5__"